// imports internos
import Cabecera from "../../components/Layout/CabeceraHomePublica";
import logo from "assets/img/logo/logo_aig_login-2.png";
// imports externos
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import LoadingScreen from "react-loading-screen";
import { Container, Col, Row } from "reactstrap";
import Iframe from "react-iframe";
import { IndemnizacionesConfig } from "../../constants/index"
import { useParams } from "react-router-dom";
import { stringABase64 } from "../../utils/Encriptar"
import { tokenIframe } from "../../redux/actions/aContenidos";



// Container Indemnizacion
const ContainerPantallaIframe = ({ carritoVisible }) => {
    // hooks
    let params = useParams();

    // redux data read
    const loadingServicios = useSelector(state => state.rServicios.serviciosIsLoading);
    const dataServicios = useSelector(state => state.rServicios.dataServicios);
    const datosUsuario = useSelector(state => state.datosUsuarios.dataUsuario);
    const idUsuarioBase64 = stringABase64(datosUsuario.cliCodigoCore);
    const [token, setToken] = useState('');

    const [url_redireccion, setUrlRedireccion] = useState('');
    const [url, setUrl] = useState('');
    const [tipo, setTipo] = useState('');






    useEffect(() => {
        console.log('dataServicios', dataServicios)
        dataServicios.map((item) => {
            if (item.parCodigo === params.tipo) {
                const u = item.URL.replace('{{idUsuario}}', idUsuarioBase64).replace('{{token}}', localStorage.getItem('tokenIframe'))
                const d = {
                    ...item,
                    URL: u
                }
                setUrlRedireccion(d)
                console.log('item', u)
                console.log('iframeVer', u)
                setUrl(u)
            }
        })
    }, [dataServicios])


    useEffect(() => {
        const t = url_redireccion ? url_redireccion.tipo : ''
        setTipo(t)
        const d = async () => {
            await tokenIframe()
        }

        d()
    }, [url_redireccion])


    useEffect(() => {
        localStorage.getItem('tokenIframe') ? setToken(localStorage.getItem('tokenIframe')) : setToken('')
    }, [])




    // manage state
    const [height, setHeight] = useState(500);

    // use effect
    // to resize iframe
    useEffect(() => {
        console.log('useEffect', dataServicios)
        let iframe = document.getElementById('iframe_indemnizacion');
        const factorHeight = 1.5
        if (iframe) {
            setHeight(factorHeight * parseInt(iframe.contentWindow.document.body.scrollHeight));
        }
    }, [])

    // return view
    return (
        <LoadingScreen
            loading={loadingServicios}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Cargando..."
        >
            <main className="cr-app-home main-bordes">
                <div className="cr-content-home" style={{ marginBottom: '4rem' }}>
                    <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <Cabecera carritoVisible={carritoVisible} />
                        </Col>
                    </Row>
                    <Row style={{ justifyContent: 'center' }}>
                        <Col lg={11} md={11} sm={11} xs={11} xl={11} >
                            <h1 style={{ marginTop: '4.0rem', marginBottom: '1.5rem' }}>{url_redireccion.Nombre}</h1>


                            {tipo == 'video' ?
                                <div style={{ width: '100%' }} align="center">
                                    <video
                                        id={params.tipo}
                                        controls
                                        controlsList="nodownload"
                                    >
                                        <source src={url} type="video/mp4" />
                                    </video>


                                </div>
                                :
                                <React.Fragment>


                              

                                    <Iframe
                                        id='iframe_indemnizacion'
                                        url={url}
                                        width='100%'
                                        height={height.toString() + 'px'}
                                        overflow='hidden'
                                        position='relative'
                                    />

                                </React.Fragment>

                            }
                        </Col>
                    </Row>
                </div>
            </main>
        </LoadingScreen>
    );

}

export default ContainerPantallaIframe;